import React, { Component } from 'react';

class renderSelectFile extends Component {
    render() {
        return (
            <ul className="list-group">
                <li className="list-group-item">
                    <span onClick={this.props.funcao}  className="badge btn btn-danger badge-danger">X</span>
                    {this.props.nome}
                </li>
            </ul>
        );
    }
}

export default renderSelectFile;


// WEBPACK FOOTER //
// ./src/container/renderSelectFile.js